import { Component, ChangeDetectionStrategy } from "@angular/core";
import { LoaderService } from "src/app/services/loader.service";

@Component({
  standalone: false,
    selector: "app-loader",
    templateUrl: "./loader.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent {
    color = "primary";
    mode = "indeterminate";
    value = 50;
    loading: any;
    constructor(private loaderService: LoaderService) {
        this.loaderService.isLoading.subscribe((loading) => {
            this.loading = loading;
        });
    }
}
